import React from "react";
import "./Dev.css";

export default function Dummy() {
  return (
    <div className="dummy-container">
      <div className="dummy-box">
        <h1 className="dummy-text">Development Under Progress</h1>
        <div className="progress-bar">
          <div className="progress-fill"></div>
        </div>
      </div>
    </div>
  );
}
